
import React from 'react';
import { Box, Card, Divider, TableBody } from '@mui/material';
import TextField from '@mui/material/TextField';
import Paginator from "../../../toolkit/Paginator";
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import { useState, useEffect, useRef } from 'react';
import { MenuItem } from "@mui/material";
import Select from "@mui/material/Select";
import DialogTitle from '@mui/material/DialogTitle';
import FormControl from '@mui/material/FormControl';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import axios from '../../../utils/fvAxios';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { ToastContainer, toast } from 'react-toastify';
import { HasScreenPermissions, HasPermissions } from '../../../utils/Token';
import INFO from '../../commom/RouteUrlInfo.json';
import PER from "../../../utils/Enums.json";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Grid, RadioGroup, FormControlLabel, Radio, CardMedia, CardActions } from '@mui/material';
import { useCallback, useMemo } from "react";
import { useDropzone } from "react-dropzone";
import { useTranslation } from "react-i18next";
import Trash from "../../../icons/trash1.svg";
import PlusIcon from "../../../icons/PlusIcon";
import Button1 from "../../../toolkit/ButtonV1";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import GetfVDateFormate from "../../../utils/Genaricfunctions";
import dayjs from 'dayjs';


export default function Uploadpreloginimages() {

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const toastNotify = (message, isSuccess = true) => {
        if (isSuccess) {
            toast.success(message, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        } else {
            toast.error(message, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
    };


    const [open, setOpen] = useState(false);
    const [number, setNumber] = useState("1");
    const [id, setId] = useState("");
    const [spinner, setSpinner] = React.useState(false);
    const [ImagesList, setImagesList] = React.useState([]);
    const [ImagesCount, setImagesCount] = React.useState("");
    const [fromDateValue, setFromDateValue] = useState(dayjs());
    const [toDateValue, setToDateValue] = useState(dayjs());
    const [IsVisible, setIsVisible] = useState(true);
    const [showAlert, setShowAlert] = useState(false);
    const [imgId, setimgId] = useState(0);
    const [files, setFiles] = useState([]);
    const [url, setUrl] = useState('');
    const [ImageId, setImageId] = useState('');
    const [ImageName, setImageName] = useState('');

    //const [fileReset, setFileReset] = useState(true);
    const { t } = useTranslation();

    const handleClickOpen = (num, data) => {
        setId(num);
        if (num == 2 || num == 3) {
            setFiles([]);
            setimgId(data?.id);
            setFromDateValue(data?.activeFrom);
            setToDateValue(data?.activeTo);
            setIsVisible(data?.isVisible);
            setUrl(data?.url);
            setImageName(data?.imageName);
            setImageId(data?.imageId);
            setOpen(true);
        } else {
            setFiles([]);
            setimgId(0);
            setFromDateValue(dayjs());
            setToDateValue(dayjs());
            setIsVisible(true);
            setUrl('');
            setImageName('');
            setImageId("00000000-0000-0000-0000-000000000000");
            setOpen(true);
        }
    };

    const handleClose = () => {
        setOpen(false);
        setimgId(0);
        setFiles([]);
        setFromDateValue(dayjs());
        setToDateValue(dayjs());
        setIsVisible(true);
        setUrl('');
    };

    const SpinnerClose = () => {
        setSpinner(false);
    };

    const handleDateKeyDown = (e) => {
        e.preventDefault();// Prevent manual date input
    };

    const activeStyle = {
        borderColor: "#2196f3",
    };
    const acceptStyle = {
        borderColor: "#00e676",
    };
    const rejectStyle = {
        borderColor: "#ff1744",
    };
    const onDrop = useCallback((acceptedFiles) => {
        setFiles(
            acceptedFiles?.map((file) =>
                Object.assign(file, {
                    preview: URL.createObjectURL(file),
                })
            )
        );
    }, []);

    const {
        getRootProps,
        getInputProps,
        isDragActive,
        isDragAccept,
        isDragReject,
    } = useDropzone({
        onDrop,
        accept: {
            'image/jpeg': ['.jpeg', '.png']
        },
        maxFiles: 1,
        // maxSize: 10615705
    });

    const mmmt = useMemo(
        () => ({
            ...(isDragActive ? activeStyle : {}),
            ...(isDragAccept ? acceptStyle : {}),
            ...(isDragReject ? rejectStyle : {}),
        }),
        [isDragActive, isDragReject, isDragAccept]
    );

    const thumbs = files?.map((file) => <div key={file?.name}>{file?.name}</div>);
    // clean up
    // useEffect(
    //     () => () => {
    //         files?.forEach((file) => URL.revokeObjectURL(file?.name));
    //     },
    //     [fileReset]
    // );

    useEffect(() => {
        GetDepartments();
    }, [number]);

    const GetDepartments = async () => {
        setSpinner(true);
        const resp = await axios.get("Login/GetLoginImages?pageNumber=" + number + "&pageSize=12");
        setImagesList(resp?.data?.data);
        setImagesCount(resp?.data?.count);
        setSpinner(false);
    }

    const handleFromDateChange = (date) => {
        setFromDateValue(date);
        if (date && toDateValue && date > toDateValue) {
            setShowAlert(true);
        } else {
            setShowAlert(false);
        }
    };

    const handleToDateChange = (date) => {
        setToDateValue(date);
        if (fromDateValue && date && fromDateValue > date) {
            setShowAlert(true);
        } else {
            setShowAlert(false);
        }
    };


    const handlePageChange = (event) => {
        setNumber(event);
    };

    const AddorEditimage = async () => {
        setSpinner(true);
        if (showAlert == false) {
            if (files[0] != null && fromDateValue != "" && toDateValue != "") {
                const formData = new FormData();
                formData.append("Id", imgId);
                formData.append("URL", url);
                formData.append("ActiveFrom", fromDateValue);
                formData.append("ActiveTo", toDateValue);
                formData.append("IsVisible", IsVisible);
                formData.append("loginImageFile", files[0]);
                formData.append("ImageId", ImageId);
                formData.append("ImageName", ImageName);


                axios.post("Login/AddOrEditLoginImage", formData)
                    .then((res) => {
                        if (res?.data?.responseCode == 100) {
                            handleClose();
                            GetDepartments();
                            toastNotify(res?.data?.responseMessage, true);
                        } else {
                            toastNotify(res?.data?.responseMessage, false);
                            setOpen(true);
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    })
                    .finally(() => {
                        setSpinner(false);
                    });
            } else {
                toastNotify("Please enter mandatory fields", false);
                setOpen(true);
                setSpinner(false);
            }
        } else {
            toastNotify("From date should be less than To date", false);
            setOpen(true);
            setSpinner(false);
        }
    }

    const DeleteImage = () => {
        setSpinner(true);
        axios.post("Login/DeleteLoginImage?id=" + imgId)
            .then((res) => {
                if (res?.data?.responseCode == 100) {
                    handleClose();
                    GetDepartments();
                    toastNotify(res?.data?.responseMessage, true);
                } else {
                    toastNotify(res?.data?.responseMessage, false);
                    setOpen(true);
                }
            })
            .catch((err) => {
                console.log(err);
            })
            .finally(() => {
                setSpinner(false);
            });
    }


    return (
        <>
            <ToastContainer />
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={spinner}
                onClick={SpinnerClose}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            <Card>
                <Dialog fullScreen={fullScreen} open={open} onClose={handleClose}>
                    {id == 3 ?
                        <DialogContent >
                            <DialogTitle
                                sx={{
                                    textAlign: "center",
                                    fontWeight: 500,
                                    fontSize: 20,
                                }}
                            >
                                <span style={{ fontSize: "larger" }} >{"Delete Image"}</span>
                            </DialogTitle>

                            <DialogActions >
                                {"Are you sure you want to delete?"}
                            </DialogActions>
                            <DialogActions >
                                <div className="login-help__buttonContainer mt-4">
                                    <Button variant="contained" className="login-help-button-cancel mx-2" onClick={handleClose}>Cancel</Button>
                                    <Button variant="contained" className="login-button-request mx-2" onClick={DeleteImage} >Delete</Button>
                                </div>

                            </DialogActions>
                        </DialogContent>
                        : <DialogContent >
                            <DialogTitle
                                sx={{
                                    textAlign: "center",
                                    fontWeight: 500,
                                    fontSize: 20,
                                }}
                            >
                                <span style={{ fontSize: "larger" }} >{id == 1 ? " Add image" : " Edit image"}</span>
                            </DialogTitle>

                            <DialogActions >
                                <div>

                                    <div className=''>
                                        <div>
                                            <span style={{ color: "#3E4A62", fontSize: "18px" }}>Upload image<span style={{ color: "red" }}>*</span></span>
                                            <br />
                                            <div
                                                className="drop"
                                                {...getRootProps({ mmmt })}
                                                style={{ padding: "10px" }}
                                            >
                                                <input {...getInputProps()} />

                                                <span className="text-muted mt-2 fs">
                                                    <b>
                                                        <span className="mx-1 cl">
                                                            {t("DragandDrop.firstLabel1")}{" "}
                                                            <span className=" text-muted Fs">
                                                                or drag and drop
                                                                <br /> Only jpg , jpeg and png files are allowed.
                                                            </span>{" "}
                                                        </span>
                                                    </b>
                                                </span>
                                                <br />

                                                <span className=" text-muted Fs"> {thumbs}</span>
                                            </div>

                                        </div>

                                        <div >
                                            <span style={{ color: "#3E4A62", fontSize: "18px" }}>From<span style={{ color: "red" }}>*</span></span>
                                            <br />
                                            <FormControl>
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <DatePicker
                                                        views={["year", "month", "day"]}
                                                        value={fromDateValue}
                                                        disabled={id == 2}
                                                        onChange={handleFromDateChange}
                                                        minDate={dayjs()}
                                                        name="fromDate"
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                sx={{
                                                                    "& legend": { display: "none" },
                                                                    "& fieldset": { top: 0 },
                                                                    width: "320px",
                                                                }}
                                                                size="small"
                                                                name="fromDate"
                                                                onKeyDown={handleDateKeyDown}
                                                            />
                                                        )}
                                                    />
                                                </LocalizationProvider>
                                            </FormControl>
                                        </div>

                                        <div className='mt-3'>
                                            <span style={{ color: "#3E4A62", fontSize: "18px" }}>To <span style={{ color: "red" }}>*</span></span>
                                            <br />

                                            <FormControl>
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <DatePicker
                                                        views={["year", "month", "day"]}
                                                        value={toDateValue}
                                                        disabled={id == 2}
                                                        name="toDate"
                                                        onChange={handleToDateChange}
                                                        minDate={dayjs()}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                sx={{
                                                                    "& legend": { display: "none" },
                                                                    "& fieldset": { top: 0 },
                                                                    width: "320px",
                                                                }}
                                                                name="toDate"
                                                                size="small"
                                                                onKeyDown={handleDateKeyDown}
                                                            />
                                                        )}
                                                    />
                                                </LocalizationProvider>

                                            </FormControl>

                                        </div>

                                        {/* <div className='mt-3'>
                                            <span style={{ color: "#3E4A62", fontSize: "18px" }}>IsVisible <span style={{ color: "red" }}>*</span></span>
                                            <br />

                                            <FormControl>
                                                <RadioGroup
                                                    aria-labelledby="demo-radio-buttons-group-label"
                                                    name="radio-buttons-group"
                                                    value={IsVisible}
                                                    onClick={(e) => setIsVisible(e?.target?.value)}
                                                >
                                                    <Stack className='mx-5' direction={"row"} spacing={5}>
                                                        <FormControlLabel disabled={id == 2} value={true} control={<Radio />} label="Yes" />
                                                        <FormControlLabel disabled={id == 2} value={false} control={<Radio />} label="No" />
                                                    </Stack>

                                                </RadioGroup>
                                            </FormControl>

                                        </div> */}

                                    </div>


                                    <DialogActions >
                                        <div className="login-help__buttonContainer mt-4">
                                            <Button variant="contained" className="login-help-button-cancel mx-2" onClick={handleClose}>Cancel</Button>
                                            <Button variant="contained" className="login-button-request mx-2" onClick={AddorEditimage}>{id == 1 ? "Add " : "Save"}</Button>
                                        </div>

                                    </DialogActions>
                                </div >
                            </DialogActions>
                        </DialogContent>
                    }
                </Dialog>

                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        padding: "15px",
                        "& svg": { m: 1.5 },
                        "& hr": { mx: 0.5 },
                    }}
                >
                    <Grid
                        container
                        wrap="nowrap"
                        sx={{ flexDirection: { xs: "column", md: "row", oveflow: "auto" } }}
                        spacing={2}
                        justify="flex-start"
                    >
                        <Grid item xs={9}>
                            <h2 style={{ float: "left" }}>
                                Upload images for login page
                            </h2>
                        </Grid>
                        <Grid item xs={3}>
                            <Button1
                                sx={{ marginLeft: "170px" }}
                                role="primary"
                                size="default"
                                trailingComponent={<PlusIcon />}
                                label="Add New"
                                onClick={() => handleClickOpen(1, "")}
                            />
                        </Grid>
                    </Grid>
                </Box>

                <Divider sx={{ height: "5px", marginBottom: 2, backgroundColor: "#667085;", height: "2px" }} />

                <Box border={1} borderLeft={1} borderRight={1} borderColor="#e4e7ec" className="mt-2" sx={{ width: "auto", padding: "10px" }}>
                    {ImagesCount === 0 ? (
                        <Box
                            hidden={spinner}
                            border={1}
                            borderLeft={1}
                            borderRight={1}
                            borderColor="#e4e7ec"
                            sx={{ padding: 2, marginTop: 4, marginBottom: "12px", marginLeft: "12px", marginRight: "12px", width: "auto" }}
                            className="text-center"
                        >
                            <span style={{ color: "#667085" }}>No images found</span>
                        </Box>
                    ) : (
                        <Grid container spacing={2}>
                            {ImagesList?.map((r) => (
                                <Grid item xs={12} sm={6} md={3} key={r.id}>
                                    <Card sx={{ width: "100%" }}>
                                        <CardMedia
                                            component="img"
                                            height="200"
                                            image={r?.url}
                                            alt="Uploaded"
                                            style={{ objectFit: "fill" }}
                                        />
                                        <CardActions sx={{ px: 2, py: 1, flexDirection: "column", alignItems: "stretch" }}>
                                            <Box
                                                sx={{
                                                    mb: 1,
                                                    color: "#667085",
                                                    fontSize: "14px",
                                                    textAlign: "center",
                                                    fontWeight: "bold",
                                                }}
                                            >
                                                From: {GetfVDateFormate(r?.activeFrom)} &nbsp; - &nbsp; To: {GetfVDateFormate(r?.activeTo)}
                                            </Box>


                                            <Box sx={{ display: "flex", justifyContent: "space-between", gap: 1 }}>
                                                <Button
                                                    variant="outlined"
                                                    fullWidth
                                                    startIcon={<EditIcon />}
                                                    onClick={() => handleClickOpen(2, r)}
                                                >
                                                    Edit
                                                </Button>
                                                <Button
                                                    variant="outlined"
                                                    color="error"
                                                    fullWidth
                                                    startIcon={<DeleteIcon />}
                                                    onClick={() => handleClickOpen(3, r)}
                                                >
                                                    Delete
                                                </Button>
                                            </Box>
                                        </CardActions>
                                    </Card>
                                </Grid>
                            ))}
                        </Grid>
                    )}
                </Box>


            </Card >
            <div hidden={ImagesCount < 1}>
                <Paginator
                    count={Math.ceil(ImagesCount / 12)}
                    page={Number(number)}
                    margin="18px 0px"
                    onChange={handlePageChange}
                />
            </div>
        </>
    )
}


